import React from 'react';
import { useLocation } from 'react-router-dom';
import { AuthorizeV2Data } from 'store/connect/AuthorizeV2Data';

/**
 * 認可エンドポイントからのリクエストを受け取るhook
 */
export const useReceiveV2AuthorizeRequest = () => {
	const location = useLocation();
	const search = location.search;
	const queryParams = new URLSearchParams(search);

	/**
	 * 認可エンドポイントv2から来た場合のパラメータ
	 * GETで飛んでくるのでReact上はURLデコードされた状態
	 */
	const response_type = queryParams.get('response_type');
	const client_id = queryParams.get('client_id');
	const redirect_uri = queryParams.get('redirect_uri');
	// stateは再エンコードして取得する
	const state = queryParams.get('state') ? encodeURIComponent(queryParams.get('state')) : queryParams.get('state');
	const prompt = queryParams.get('prompt');
	const gid_dp = queryParams.get('gid_dp'); // ログイン画面情報のシリアルナンバー
	const gid_act = queryParams.get('gid_act');
	const code_challenge = queryParams.get('code_challenge');
	const code_challenge_method = queryParams.get('code_challenge_method');
	const gid_reg_act = queryParams.get('gid_reg_act');
	const scope = queryParams.get('scope');
	const nonce = queryParams.get('nonce');
	const isV2ParamsOk = response_type === 'code' && !!client_id;
	const v2Params: AuthorizeV2Data = {
		response_type,
		client_id,
		redirect_uri,
		state,
		prompt,
		gid_dp,
		gid_act,
		code_challenge,
		code_challenge_method,
		gid_reg_act,
		scope,
		nonce,
	};

	return {
		v2Params,
		isV2ParamsOk,
	};
};
